import { FamilyTemplate } from './types';

// Template definitions for all 45 feature families.
// 30 are pure segment templates, 8 are aliases, 7 are custom (code-based).
// This data structure is the shareable contract between TS and Python.

export const familyTemplates: Record<string, FamilyTemplate> = {
  // --- Pure segment templates (30 families) ---

  '1': {
    type: 'segments',
    segments: [
      { type: 'area', path: 'a' },
      { type: 'lit', v: ' area' },
    ],
    applyStain: true,
  },
  '2': {
    type: 'segments',
    segments: [
      { type: 'area', path: 'numerator.a' },
      { type: 'lit', v: ' to ' },
      { type: 'area', path: 'denominator.a' },
      { type: 'lit', v: ' ratio' },
    ],
    applyStain: true,
  },
  '3': {
    type: 'segments',
    segments: [
      { type: 'cell', c: 'c', s: 's', cls: 'classifiers' },
      { type: 'lit', v: ' count in ' },
      { type: 'area', path: 'a' },
    ],
  },
  '4': {
    type: 'segments',
    segments: [
      { type: 'grid_prefix' },
      { type: 'cell', c: 'c', s: 's', cls: 'classifiers' },
      { type: 'lit', v: ' fraction out of all cells' },
      { type: 'grid_threshold' },
      { type: 'lit', v: ' in ' },
      { type: 'area', path: 'a' },
      { type: 'grid_suffix' },
    ],
  },
  '5': {
    type: 'segments',
    segments: [
      { type: 'grid_prefix' },
      { type: 'cell', c: 'numerator.c', s: 's', cls: 'numerator.classifiers' },
      { type: 'lit', v: ' to ' },
      { type: 'cell', c: 'denominator.c', s: 's', cls: 'denominator.classifiers' },
      { type: 'lit', v: ' ratio' },
      { type: 'grid_threshold' },
      { type: 'lit', v: ' in ' },
      { type: 'area', path: 'a' },
      { type: 'grid_suffix' },
    ],
  },
  '6': {
    type: 'segments',
    segments: [
      { type: 'grid_prefix' },
      { type: 'cell', c: 'c', s: 's', cls: 'classifiers' },
      { type: 'lit', v: ' density' },
      { type: 'grid_threshold' },
      { type: 'lit', v: ' in ' },
      { type: 'area', path: 'a' },
      { type: 'grid_suffix' },
    ],
  },
  '8': {
    type: 'segments',
    segments: [
      { type: 'cell', c: 'numerator.c', s: 's', cls: 'numerator.classifiers' },
      { type: 'lit', v: ' density in ' },
      { type: 'area', path: 'numerator.a' },
      { type: 'lit', v: ' to ' },
      { type: 'cell', c: 'denominator.c', s: 's', cls: 'denominator.classifiers' },
      { type: 'lit', v: ' density in ' },
      { type: 'area', path: 'denominator.a' },
      { type: 'lit', v: ' ratio' },
    ],
  },
  '9': {
    type: 'segments',
    segments: [
      { type: 'lit', v: 'mean percent ' },
      { type: 'cell', c: 'neighbor.c', s: 's', cls: 'neighbor.classifiers' },
      { type: 'lit', v: ' within ' },
      { type: 'raw', path: 'max_dist' },
      { type: 'lit', v: ' um of ' },
      { type: 'cell', c: 'target.c', s: 's', cls: 'target.classifiers' },
      { type: 'lit', v: ' in ' },
      { type: 'area', path: 'a' },
    ],
  },
  '10': {
    type: 'segments',
    segments: [
      { type: 'param', path: 'reduction' },
      { type: 'lit', v: ' percent ' },
      { type: 'cell', c: 'neighbor.c', s: 's', cls: 'neighbor.classifiers' },
      { type: 'lit', v: ' within ' },
      { type: 'raw', path: 'max_dist' },
      { type: 'lit', v: ' um of ' },
      { type: 'cell', c: 'target.c', s: 's', cls: 'target.classifiers' },
      { type: 'lit', v: ' in ' },
      { type: 'area', path: 'numerator.a' },
      { type: 'lit', v: ' to ' },
      { type: 'param', path: 'reduction' },
      { type: 'lit', v: ' percent ' },
      { type: 'cell', c: 'neighbor.c', s: 's', cls: 'neighbor.classifiers' },
      { type: 'lit', v: ' within ' },
      { type: 'raw', path: 'max_dist' },
      { type: 'lit', v: ' um of ' },
      { type: 'cell', c: 'target.c', s: 's', cls: 'target.classifiers' },
      { type: 'lit', v: ' in ' },
      { type: 'area', path: 'denominator.a' },
      { type: 'lit', v: ' ratio' },
    ],
  },
  '11': {
    type: 'segments',
    segments: [
      { type: 'param', path: 'reduction' },
      { type: 'lit', v: ' percent ' },
      { type: 'cell', c: 'numerator.neighbor.c', s: 's', cls: 'numerator.neighbor.classifiers' },
      { type: 'lit', v: ' within ' },
      { type: 'raw', path: 'max_dist' },
      { type: 'lit', v: ' um of ' },
      { type: 'cell', c: 'target.c', s: 's', cls: 'target.classifiers' },
      { type: 'lit', v: ' in ' },
      { type: 'area', path: 'a' },
      { type: 'lit', v: ' to ' },
      { type: 'param', path: 'reduction' },
      { type: 'lit', v: ' percent ' },
      { type: 'cell', c: 'denominator.neighbor.c', s: 's', cls: 'denominator.neighbor.classifiers' },
      { type: 'lit', v: ' within ' },
      { type: 'raw', path: 'max_dist' },
      { type: 'lit', v: ' um of ' },
      { type: 'cell', c: 'target.c', s: 's', cls: 'target.classifiers' },
      { type: 'lit', v: ' in ' },
      { type: 'area', path: 'a' },
      { type: 'lit', v: ' ratio' },
    ],
  },
  '12': {
    type: 'segments',
    segments: [
      { type: 'lit', v: 'percent ' },
      { type: 'cell', c: 'target.c', s: 's', cls: 'target.classifiers' },
      { type: 'lit', v: ' with at least ' },
      { type: 'raw', path: 'min_neighbors' },
      { type: 'lit', v: ' ' },
      { type: 'cell', c: 'neighbor.c', s: 's', cls: 'neighbor.classifiers' },
      { type: 'lit', v: ' neighbors within ' },
      { type: 'raw', path: 'max_dist' },
      { type: 'lit', v: ' um in ' },
      { type: 'area', path: 'a' },
    ],
  },
  '13': {
    type: 'segments',
    segments: [
      { type: 'lit', v: 'percent ' },
      { type: 'cell', c: 'target.c', s: 's', cls: 'target.classifiers' },
      { type: 'lit', v: ' with at least ' },
      { type: 'raw', path: 'min_neighbors' },
      { type: 'lit', v: ' ' },
      { type: 'cell', c: 'neighbor.c', s: 's', cls: 'neighbor.classifiers' },
      { type: 'lit', v: ' neighbors within ' },
      { type: 'raw', path: 'numerator.max_dist' },
      { type: 'lit', v: ' um to ' },
      { type: 'raw', path: 'denominator.max_dist' },
      { type: 'lit', v: ' um in ' },
      { type: 'area', path: 'a' },
      { type: 'lit', v: ' ratio' },
    ],
  },
  '14': {
    type: 'segments',
    segments: [
      { type: 'lit', v: 'percent ' },
      { type: 'cell', c: 'target.c', s: 's', cls: 'target.classifiers' },
      { type: 'lit', v: ' with at least ' },
      { type: 'raw', path: 'min_neighbors' },
      { type: 'lit', v: ' ' },
      { type: 'cell', c: 'neighbor.c', s: 's', cls: 'neighbor.classifiers' },
      { type: 'lit', v: ' neighbors within ' },
      { type: 'raw', path: 'max_dist' },
      { type: 'lit', v: ' um in ' },
      { type: 'area', path: 'numerator.a' },
      { type: 'lit', v: ' to ' },
      { type: 'area', path: 'denominator.a' },
      { type: 'lit', v: ' ratio' },
    ],
  },
  '15': {
    type: 'segments',
    segments: [
      { type: 'cell', c: 'c', s: 's', cls: 'classifiers' },
      { type: 'lit', v: ' ' },
      { type: 'param', path: 'reduction' },
      { type: 'lit', v: ' nucleus ' },
      { type: 'text', path: 'f_type' },
      { type: 'lit', v: ' in ' },
      { type: 'area', path: 'a' },
    ],
  },
  '16': {
    type: 'segments',
    segments: [
      { type: 'cell', c: 'source_s.subset.c', s: 'source_s.s', cls: 'source_s.subset.classifiers' },
      { type: 'lit', v: ' and ' },
      { type: 'cell', c: 'target_s.subset.c', s: 'target_s.s', cls: 'target_s.subset.classifiers' },
      { type: 'lit', v: ' colocalization by joint density (sigma: ' },
      { type: 'raw', path: 'sigma' },
      { type: 'lit', v: ', thresh: ' },
      { type: 'raw', path: 'thresh' },
      { type: 'lit', v: ') in ' },
      { type: 'area', path: 'a' },
    ],
  },
  '17': {
    type: 'segments',
    segments: [
      { type: 'cell_stripped', c: 'subset.c', s: 'subset.s', cls: 'subset.classifiers' },
      { type: 'lit', v: ' coexpression of (' },
      { type: 'stain', path: 'source_s.s' },
      { type: 'lit', v: '+, ' },
      { type: 'stain', path: 'target_s.s' },
      { type: 'lit', v: '+) by joint density (sigma: ' },
      { type: 'raw', path: 'sigma' },
      { type: 'lit', v: ', thresh: ' },
      { type: 'raw', path: 'thresh' },
      { type: 'lit', v: ')' },
    ],
  },
  '19': {
    type: 'segments',
    segments: [
      { type: 'cell_stripped', c: 'numerator.subset.c', s: 'numerator.subset.s', cls: 'numerator.subset.classifiers' },
      { type: 'lit', v: ' coexpression of (' },
      { type: 'stain', path: 'numerator.source_s.s' },
      { type: 'lit', v: '+, ' },
      { type: 'stain', path: 'numerator.target_s.s' },
      { type: 'lit', v: '+) by joint density to ' },
      {
        type: 'cell_stripped',
        c: 'denominator.subset.c',
        s: 'denominator.subset.s',
        cls: 'denominator.subset.classifiers',
      },
      { type: 'lit', v: ' coexpression of (' },
      { type: 'stain', path: 'denominator.source_s.s' },
      { type: 'lit', v: '+, ' },
      { type: 'stain', path: 'denominator.target_s.s' },
      { type: 'lit', v: '+) by joint density ratio (sigma: ' },
      { type: 'raw', path: 'sigma' },
      { type: 'lit', v: ', thresh: ' },
      { type: 'raw', path: 'thresh' },
      { type: 'lit', v: ')' },
    ],
  },
  '20': {
    type: 'segments',
    segments: [
      { type: 'param', path: 'reduction' },
      { type: 'lit', v: ' percent ' },
      { type: 'cell', c: 'neighbor.c', s: 'neighbor.s', cls: 'neighbor.classifiers' },
      { type: 'lit', v: ' within ' },
      { type: 'raw', path: 'max_dist' },
      { type: 'lit', v: ' um of ' },
      { type: 'cell', c: 'target.c', s: 'target.s', cls: 'target.classifiers' },
      { type: 'lit', v: ' in ' },
      { type: 'area', path: 'a' },
    ],
  },
  '21': {
    type: 'segments',
    segments: [
      { type: 'lit', v: 'percent ' },
      { type: 'cell', c: 'target.c', s: 'target.s', cls: 'target.classifiers' },
      { type: 'lit', v: ' with at least ' },
      { type: 'raw', path: 'min_neighbors' },
      { type: 'lit', v: ' ' },
      { type: 'cell', c: 'neighbor.c', s: 'neighbor.s', cls: 'neighbor.classifiers' },
      { type: 'lit', v: ' neighbors within ' },
      { type: 'raw', path: 'max_dist' },
      { type: 'lit', v: ' um in ' },
      { type: 'area', path: 'a' },
    ],
  },
  '23': {
    type: 'segments',
    segments: [
      { type: 'cell', c: 'numerator.c', s: 's', cls: 'numerator.classifiers' },
      { type: 'lit', v: ' in ' },
      { type: 'area', path: 'numerator.a' },
      { type: 'lit', v: ' to ' },
      { type: 'cell', c: 'denominator.c', s: 's', cls: 'denominator.classifiers' },
      { type: 'lit', v: ' in ' },
      { type: 'area', path: 'denominator.a' },
      { type: 'lit', v: ' ratio' },
    ],
  },
  '24': {
    type: 'segments',
    segments: [
      { type: 'param', path: 'reduction' },
      { type: 'lit', v: ' percent ' },
      { type: 'cell', c: 'neighbor.c', s: 's', cls: 'neighbor.classifiers' },
      { type: 'lit', v: ' within ' },
      { type: 'raw', path: 'max_dist' },
      { type: 'lit', v: ' um of ' },
      { type: 'cell', c: 'target.c', s: 's', cls: 'target.classifiers' },
      { type: 'lit', v: ' in ' },
      { type: 'area', path: 'a' },
    ],
  },
  '25': {
    type: 'segments',
    segments: [
      { type: 'lit', v: 'shannon diversity index for ' },
      { type: 'cell', c: 'c', s: 's', cls: 'classifiers' },
      { type: 'lit', v: ' in ' },
      { type: 'area', path: 'a' },
    ],
  },
  '26': {
    type: 'segments',
    segments: [
      { type: 'lit', v: 'clark evans index for ' },
      { type: 'cell', c: 'c', s: 's', cls: 'classifiers' },
      { type: 'lit', v: ' in ' },
      { type: 'area', path: 'a' },
    ],
  },
  '27': {
    type: 'segments',
    segments: [
      { type: 'lit', v: "geary's c for " },
      { type: 'cell', c: 'target.c', s: 's', cls: 'target.classifiers' },
      { type: 'lit', v: ' to ' },
      { type: 'cell', c: 'neighbor.c', s: 's', cls: 'neighbor.classifiers' },
      { type: 'lit', v: ' in ' },
      { type: 'area', path: 'a' },
      { type: 'lit', v: ' (distance method: ' },
      { type: 'text', path: 'distance_method' },
      { type: 'lit', v: ', max distance: ' },
      { type: 'raw', path: 'max_dist' },
      { type: 'lit', v: ' um)' },
    ],
  },
  '28': {
    type: 'segments',
    segments: [
      { type: 'lit', v: "moran's i " },
      { type: 'statistic', path: 'statistic' },
      { type: 'lit', v: 'for ' },
      { type: 'cell', c: 'target.c', s: 's', cls: 'target.classifiers' },
      { type: 'lit', v: ' to ' },
      { type: 'cell', c: 'neighbor.c', s: 's', cls: 'neighbor.classifiers' },
      { type: 'lit', v: ' in ' },
      { type: 'area', path: 'a' },
      { type: 'lit', v: ' (distance method: ' },
      { type: 'text', path: 'distance_method' },
      { type: 'lit', v: ', max distance: ' },
      { type: 'raw', path: 'max_dist' },
      { type: 'lit', v: ' um)' },
    ],
  },
  '29': {
    type: 'segments',
    segments: [
      { type: 'lit', v: "ripley's " },
      { type: 'raw', path: 'f_type' },
      { type: 'lit', v: ' function for ' },
      { type: 'cell', c: 'c', s: 's', cls: 'classifiers' },
      { type: 'lit', v: ' in ' },
      { type: 'area', path: 'a' },
      { type: 'lit', v: ' (cell radius: ' },
      { type: 'raw', path: 'cell_radius' },
      { type: 'lit', v: ' um, max distance: ' },
      { type: 'raw', path: 'max_dist' },
      { type: 'lit', v: ' um)' },
    ],
  },
  '30': {
    type: 'segments',
    segments: [
      { type: 'lit', v: 'count of ' },
      { type: 'area', path: 'a' },
      { type: 'lit', v: ' region instances' },
      {
        type: 'optional',
        condition: 'containing_a',
        segments: [
          { type: 'lit', v: ' in ' },
          { type: 'area', path: 'containing_a' },
        ],
      },
    ],
  },
  '33': {
    type: 'segments',
    segments: [
      { type: 'cell_stripped', c: 'c', s: 's', cls: 'classifiers' },
      { type: 'lit', v: ' nuclear to cytoplasm ratio in ' },
      { type: 'area', path: 'a' },
    ],
    applyStain: true,
  },
  '34': {
    type: 'segments',
    segments: [
      { type: 'cell', c: 'c', s: 's', cls: 'classifiers' },
      { type: 'lit', v: ' density by distance to ' },
      { type: 'area', path: 'boundary.a' },
      { type: 'lit', v: ' boundary in ' },
      { type: 'area', path: 'a' },
      { type: 'lit', v: ' (interval: ' },
      { type: 'raw', path: 'interval_size' },
      { type: 'lit', v: ' um)' },
    ],
  },
  '45': {
    type: 'segments',
    segments: [
      { type: 'param', path: 'reduction' },
      { type: 'lit', v: ' ' },
      { type: 'text', path: 'f_type' },
      { type: 'lit', v: ' ' },
      { type: 'area', path: 'a' },
      { type: 'lit', v: ' in ' },
      { type: 'area', path: 'containing_a' },
    ],
  },

  // --- Aliases (8 families) ---

  '35': { type: 'alias', target: '6' },
  '36': { type: 'alias', target: '8' },
  '37': { type: 'alias', target: '34' },
  '38': { type: 'alias', target: '1' },
  '39': { type: 'alias', target: '12' },
  '40': { type: 'alias', target: '13' },
  '41': { type: 'alias', target: '14' },
  '42': { type: 'alias', target: '21' },

  // --- Custom families (8 families — logic too complex for declarative templates) ---
  // These delegate to code-based handlers in the evaluator.

  '7': { type: 'custom' },
  '18': { type: 'custom' },
  '32': { type: 'custom' },
  '43': { type: 'custom' },
  '44': { type: 'custom' },
  '46': { type: 'custom' },
  '47': { type: 'custom' },
  '49': { type: 'custom' },
};
